/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, string,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { isEmpty } from '../../../utils/object';
import { decode as htmlDecode } from '../../../utils/htmlEntity';

const useStyles = makeStyles(() => ({
    container: {
        padding: '10px 0px 12px',
        fontSize: '16px',
        fontStyle: 'italic !important',
        fontWeight: '400',
        lineHeight: 'normal',
        display: 'flex',
        borderTop: '1px solid #D5D5D5',
        justifyContent: 'flex-end',
    },
    contentWrapper: {
        width: 'calc(100% - 81px)',
        '@media only screen and (max-width: 1023.5px) ': {
            width: '100%',
        },
    },
    productName: {
        fontWeight: '500',
    },
}));

const ProductAddedToCart = ({
    recipient,
}) => {
    if (isEmpty(recipient.cartDetail)) return null;
    const classes = useStyles();
    const product = recipient.cartDetail;
    const newName = htmlDecode(product.productDetail.name);
    return (
        <div className={classes.container}>
            <div className={classes.contentWrapper}>
                <span className={classes.productName}>
                    {newName} &nbsp;
                </span>is currently in your cart
            </div>
        </div>
    );
};

ProductAddedToCart.defaultProps = {
    recipient: {},
};

ProductAddedToCart.propTypes = {
    recipient: shape({
        products: shape({
            productDetail: shape({
                name: string,
            }),
        }),
        type: string,
    }),
};

export default ProductAddedToCart;
